import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { ref, onValue } from 'firebase/database';
import { database } from '../../utils/firebase';

const HandicapReport = () => {
    const { leagueId, handicapId, print, header } = useParams();
    const [flights, setFlights] = useState([]);
    const [players, setPlayers] = useState([]);
    const [leagueSettings, setLeagueSettings] = useState({});
    const [handicapInfo, setHandicapInfo] = useState({ startDate: null, endDate: null, name: null });
    const [leagueData, setLeagueData] = useState({});

    useEffect(() => {
        const leagueRef = ref(database, `leagues/${leagueId}`);
        onValue(leagueRef, (snapshot) => {
            const data = snapshot.val();
            if (data) {
                setLeagueData(data);
                setLeagueSettings(data.settings);
            } else {
                console.error('No settings found for the given leagueId.');
            }
        }, (error) => {
            console.error('Error fetching league settings from Firebase:', error);
        });
    }, [leagueId]);

    useEffect(() => {
        const handicapRef = ref(database, `leagues/${leagueId}/handicaps/${handicapId}`);
        onValue(handicapRef, (snapshot) => {
            const data = snapshot.val();
            if (data) {
                setFlights(Object.values(data.flights));
                setHandicapInfo({ startDate: data.startDate, endDate: data.endDate, name: data.name });
                const playerHandicaps = data.playerHandicaps;
                const playersRef = ref(database, `leagues/${leagueId}/players`);
                onValue(playersRef, (snapshot) => {
                    const playersData = snapshot.val();
                    if (playersData) {
                        const playersList = Object.keys(playerHandicaps).map(playerId => ({
                            name: playersData[playerId].name,
                            handicap: playerHandicaps[playerId]
                        }));
                        setPlayers(playersList);
                    } else {
                        console.log('No players found for the given leagueId.');
                    }
                }, (error) => {
                    console.error('Error fetching players from Firebase:', error);
                });
            } else {
                console.log('No handicap data found for the given handicapId.');
            }
            if (print === 'true') {
                setTimeout(() => {
                    window.print();
                }, 100); // 2 seconds delay
            }
        }, (error) => {
            console.error('Error fetching handicap data from Firebase:', error);
        });
    }, [leagueId, handicapId]);

    const formatDate = (timestamp) => {
        const options = { month: 'short', day: 'numeric', year: 'numeric' };
        return new Date(timestamp * 1000).toLocaleDateString(leagueSettings.language, options);
    };

    return (
        <div style={{backgroundColor: '#ffffff'}}>
            <div className={'modern-report report-container'}>
                <div className="modern-report-container">
                    {header === 'true' && (
                        <div className={'modern-report-header'}>
                            <h1>Handicap Report</h1>
                            <h3>{leagueData.name}</h3>
                            <h4>{leagueData.parentGroup}</h4>
                            <h4>{handicapInfo.name}</h4>
                            <h4>{handicapInfo.startDate && handicapInfo.endDate ? `${formatDate(handicapInfo.startDate)} - ${formatDate(handicapInfo.endDate)}` : ''}</h4>
                        </div>
                    )}
                    <h1>Flights</h1>
                    <table>
                        <thead>
                            <tr>
                                <th width="40%">Flight</th>
                                <th width="30%">Handicaps</th>
                                <th width="30%">Players</th>
                            </tr>
                        </thead>
                        <tbody>
                            {flights.map((flight, index) => (
                                <tr key={index}>
                                    <td>{flight.name}</td>
                                    <td>{flight.start} - {flight.end}</td>
                                    <td>{Object.values(players).filter(player => player.handicap >= flight.start && player.handicap <= flight.end).length}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>

                    <h1>Players</h1>
                    <table>
                        <thead>
                            <tr>
                                <th width="70%">Player Name</th>
                                <th width="30%">Handicap</th>
                            </tr>
                        </thead>
                        <tbody>
                            {players.map((player, index) => (
                                <tr key={index}>
                                    <td>{player.name}</td>
                                    <td>{player.handicap}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default HandicapReport;